import { render, staticRenderFns } from "./MypageResignPage.vue?vue&type=template&id=a15e30ea&"
import script from "./MypageResignPage.vue?vue&type=script&lang=js&"
export * from "./MypageResignPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports